// extracted by mini-css-extract-plugin
export default {"root":"CancelRequestModalSuccessStage_root__LuhaL","cancelled":"CancelRequestModalSuccessStage_cancelled__CxFOr"};